<template>
  <div class="fadeIn user-wrapper">
    <h2><b>{{title}} {{$t('user.user')}}</b></h2>

    <div class="form-container">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-12">

          <div class="card">
            <div class="card-header">
              <h5><b>{{$t('user.userDetails')}}</b></h5>
            </div>
            <div class="card-body" style="padding: 25px 30px 26px 15px;">
              <div class="row ">
                <div class="col-3">
                  <div class="d-flex flex-column align-items-center">
                    <img v-if="userData.photo_url" :src="userData.photo_url" class="user-image">
                    <img v-else src="@/assets/default-user.jpg" class="user-image">
                    <br>
                    <label for="files" class="bnt btn-link " v-text="btnPhoto"></label>
                    <input id="files" style="visibility:hidden;" type="file" @change="onFileChanged" accept="image/*" />
                  </div>

                </div>
                <div class="col-9">
                  <form ref="form" @submit="onSubmit($event)">
                    <ValidationObserver v-slot="{ valid }" ref="validator">  
                      <div class="row">
                      
                        
                        <div class="form-group col-12 col-md-6">
                          <label for="username">{{$t('user.username')}}</label>
                          <input type="text" class="form-control" id="username" v-model="userData.username" />
                        </div>
                        <div class="form-group col-12 col-md-6">
                          <label for="email">{{$t('user.email')}}</label>
                          <input type="email" class="form-control" id="email" v-model="userData.email" />
                        </div>
                        <ValidationProvider rules="required" v-slot="{ errors }" class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="name">{{$t('user.firstName')}} <span class="required">*</span></label>
                            <input type="text" :class="{'error': errors.length, 'form-control': true}" id="name" v-model="userData.name" />
                          </div>
                        </ValidationProvider>
                        <div class="form-groupcol-12 col-md-6">
                          <label for="last_name">{{$t('user.lastName')}}</label>
                          <input type="text" class="form-control" id="last_name" v-model="userData.last_name" />
                        </div>
                        <ValidationProvider v-if="isAdminOrOperationsUser() || isGroundWorxAgent() || state === 'CreateUser'" rules="required" v-slot="{ errors }" class="col-12 col-md-6">
                          <div class="form-group" >
                            <label for="user_type">{{$t('user.role')}} <span class="required">*</span></label>
                            <select v-model="userData.type_id" :class="{'error': errors.length, 'form-control': true, 'gw-select': true}" id="user_type">
                              <option :value="null">- {{ $t('general.select') }} -</option>
                              <option v-if="isAdminOrOperationsUser()" :value="consts.UserType.ADMIN">{{ $t('users.role_1') }}</option>
                              <option :value="consts.UserType.ASSIST_HEAD_GROUNDSMAN">{{ $t('users.role_22') }}</option>
                              <option :value="consts.UserType.ASSIST_HEAD_GROUNDS_PERSON">{{ $t('users.role_24') }}</option>
                              <option :value="consts.UserType.ASSISTANT_SUPERINTENDENT">{{ $t('users.role_12') }}</option>
                              <option :value="consts.UserType.CEO">{{ $t('users.role_36') }}</option>
                              <option :value="consts.UserType.CLUB_MANAGER">{{ $t('users.role_18') }}</option>
                              <option :value="consts.UserType.COURSE_OPERATIONS">{{ $t('users.role_15') }}</option>
                              <option :value="consts.UserType.DIRECTOR_AGRONOMY">{{ $t('users.role_13') }}</option>
                              <option :value="consts.UserType.DIRECTOR_ATHLETIC_FACILITIES">{{ $t('users.role_29') }}</option>
                              <option :value="consts.UserType.DIRECTOR_GOLF">{{ $t('users.role_16') }}</option>
                              <option :value="consts.UserType.DIRECTOR_WATER_MANAGEMENT">{{ $t('users.role_31') }}</option>
                              <option :value="consts.UserType.FOREMAN">{{ $t('users.role_5') }}</option>
                              <option :value="consts.UserType.GENERAL_MANAGER">{{ $t('users.role_14') }}</option>
                              <option :value="consts.UserType.GREENSKEEPER">{{ $t('users.role_19') }}</option>
                              <option :value="consts.UserType.GROUNDS_MANAGER">{{ $t('users.role_34') }}</option>
                              <option :value="consts.UserType.GROUNDS_SUPERVISOR">{{ $t('users.role_25') }}</option>
                              <option v-if="isAdminOrOperationsUser()" :value="consts.UserType.GROUNDWORX">{{ $t('users.role_11') }}</option>
                              <option v-if="isAdminOrOperationsUser()" :value="consts.UserType.AGENT">{{ $t('users.role_3') }}</option>
                              <option :value="consts.UserType.HEAD_GROUNDSMAN">{{ $t('users.role_21') }}</option>
                              <option :value="consts.UserType.HEAD_GROUNDS_PERSON">{{ $t('users.role_23') }}</option>
                              <option :value="consts.UserType.HEAD_PROFESSIONAL">{{ $t('users.role_17') }}</option>
                              <option :value="consts.UserType.IRRIGATION_SPECIALIST">{{ $t('users.role_33') }}</option>
                              <option :value="consts.UserType.LANDSCAPE_SUPERVISOR">{{ $t('users.role_30') }}</option>
                              <option :value="consts.UserType.LEAN_GROUNDSMAN">{{ $t('users.role_35') }}</option>
                              <option :value="consts.UserType.LIVING_TURF">{{ $t('users.role_38') }}</option>
                              <option :value="consts.UserType.MANAGER">{{ $t('users.role_7') }}</option>
                              <option v-if="isAdminOrOperationsUser()" :value="consts.UserType.OPERATIONS">{{ $t('users.role_2') }}</option>
                              <option :value="consts.UserType.PARKS_SUPERINTENDENT">{{ $t('users.role_27') }}</option>
                              <option :value="consts.UserType.PARKS_SUPERVISOR">{{ $t('users.role_26') }}</option>
                              <option v-if="isAdminOrOperationsUser() && state !== 'CreateUser' && current_user.type_id == consts.UserType.PROSPECT" :value="consts.UserType.PROSPECT">{{ $t('users.role_9') }}</option>
                              <option :value="consts.UserType.RESEARCH_AGRONOMIST">{{ $t('users.role_37') }}</option>
                              <option :value="consts.UserType.STAFF">{{ $t('users.role_6') }}</option>
                              <option :value="consts.UserType.SPORTS_TURG_MANAGER">{{ $t('users.role_28') }}</option>
                              <option :value="consts.UserType.SUPERINTENDENT">{{ $t('users.role_4') }}</option>
                              <option :value="consts.UserType.SVP_AGRONOMY">{{ $t('users.role_20') }}</option>
                              <option :value="consts.UserType.WATER_MANAGER">{{ $t('users.role_32') }}</option>
                            </select>
                          </div>
                        </ValidationProvider>
                        <div class="form-group col-12 col-md-6">
                          <label for="phone">{{$t('user.phone')}}</label>
                          <input type="text" class="form-control" id="phone" v-model="userData.phone" />
                        </div>
                        <ValidationProvider v-if="state === 'CreateUser'" name="newPassword" rules="required" v-slot="{ errors }" class="col-12 col-md-6">
                          <div class="form-group" v-if="state === 'CreateUser'">
                            <label for="password">{{$t('user.password')}} <span class="required">*</span></label>
                            <GwPassword v-model="userData.password" :g-class="errors.length ? 'error' : '' " />
                          </div>
                        </ValidationProvider>
                        <ValidationProvider rules="required" v-slot="{ errors }" class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="user_status">{{$t('general.status')}} <span class="required">*</span></label>
                            <select v-model="userData.status" :class="{'error': errors.length, 'form-control': true, 'gw-select': true}" id="user_status">
                              <option v-for="(option, index) in consts.UserStatus" v-bind:key="index" v-bind:value="option.status">
                                {{ option.text }}
                              </option>
                            </select>
                          </div>
                        </ValidationProvider>
                        <ValidationProvider v-if="isAdminOrOperationsUser() && (state === 'CreateUser' || (current_user.type_id == consts.UserType.PROSPECT && userData.type_id !== consts.UserType.PROSPECT ))" 
                                            rules="required" v-slot="{ errors }" class="col-12 col-md-6">
                          <div class="form-group">
                            <label for="user_course">{{$t('facility.facilityAssociated')}} <span class="required">*</span></label>
                            <select v-model="selected_course_id" :class="{'error': errors.length, 'form-control': true, 'gw-select': true}" id="user_course">
                              <option :value="null">Select one</option>
                              <option v-for="(course, index) in userCourses" v-bind:key="index" v-bind:value="course.course_id">
                                {{ course.name }}
                              </option>
                            </select>
                          </div>
                        </ValidationProvider>
                        <div v-if="isAdminOrOperationsUser() && (state === 'CreateUser' || (current_user.type_id == consts.UserType.PROSPECT && userData.type_id !== consts.UserType.PROSPECT ))" class="form-group col-12 col-md-6">
                          <label for="notifications">{{$t('users.turnOnNotifications')}}</label>
                          <select v-model="activate_notifications" class="form-control gw-select" id="notifications">
                              <option :value="false">{{ $t('general.no') }}</option>
                              <option :value="true">{{ $t('general.yes') }}</option>
                            </select>
                        </div>
                      </div>
                    </ValidationObserver>

                    
                    <button v-if="hasPasswordInput" type="submit" class="btn btn-primary medium f-right" :disabled="loading.updating || !passwordIsValid">
                      <span class="spinner-border spinner-border-sm" v-show="loading.updating" />
                      {{$t('general.save')}}
                    </button>

                    <button v-else type="submit" class="btn btn-primary medium f-right" :disabled="loading.updating">
                      <span class="spinner-border spinner-border-sm" v-show="loading.updating" />
                      {{$t('general.save')}}
                    </button>
                                        
                    <router-link to="/users" class="btn btn-secondary medium f-right mx-3">
                      {{$t('general.cancel')}}
                    </router-link>
                    <button type="button" @click="deleteUser" class="btn btn-danger medium f-right " :disabled="loading.deliting"
                      v-if="this.state === 'UpdateUser' && scCanDelete">
                      <span class="spinner-border spinner-border-sm" v-show="loading.deliting" />
                      {{$t('user.deleteUser')}}
                    </button>
                    <br><br>
                  </form>
                </div>
              </div>

            </div>

          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import GwPassword from '@/components/gwPassword/GwPassword.vue';
  import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
  import { required, password } from 'vee-validate/dist/rules';
  
  import {
    saveUser,
    updateUser,
    getUser,
    uploadUserPhoto,
    uploadPhotoNewUser,
    upgradeProspect,
  } from '@/api/index';
  import {
    mapActions,
    mapMutations,
  } from 'vuex';
  import {
    omit,
  } from 'lodash';

  import { mapState } from 'vuex';

  export default {
    name: 'UserOpertaions',
    components: {
      ValidationProvider,
      ValidationObserver,
      GwPassword,
    },
    data() {
      return {
        title: '',
        btnPhoto: '',
        state: this.$router.currentRoute.name,
        loading: {
          updating: false,
          deliting: false,
        },
        selected_course_id: null,
        current_user: null,
        userData: {
          photo_url: '',
          email: '',
          username: '',
          name: '',
          last_name: '',
          type_id: null,
          phone: '',
          password: '',
          status: 'ACTIVE',
        },
        tempPhoto: {
          file: null,
          name: null,
        },
        scCanDelete: false,
        activate_notifications: false,
        hasPasswordInput:false,
      };
    },
    computed: {
      ...mapState({
        userCourses: (state) => state.userCourses,
      }),
      passwordIsValid (){
      
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.*[0-9]).{8,}$/;    
        return regex.test(this.userData.password);
      
  },
  
     
    },
    methods: {
      ...mapActions('Users', ['apiDeleteUser']),
      ...mapMutations('Users', ['setUserSelected']),
      isAdminOrOperationsUser() {
        return (this.$store.state.user.user_type.type_id == this.consts.UserType.ADMIN ||
                this.$store.state.user.user_type.type_id == this.consts.UserType.OPERATIONS);
      },

      checkPasswordInput() {
      // Verificar si existe un campo de contraseña en el formulario
      console.log(this.hasPasswordInput)
      this.hasPasswordInput = this.$refs.form.querySelector('input[type="password"]');
      console.log(this.hasPasswordInput)
      
    },
      isSuperIntendetOrEquivalent() {
      return (this.$store.state.user.user_type.type_id == this.consts.UserType.SUPERINTENDENT ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.DIRECTOR_AGRONOMY ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.GENERAL_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.COURSE_OPERATIONS ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.DIRECTOR_GOLF ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.HEAD_PROFESSIONAL ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.CLUB_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.GREENSKEEPER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.SVP_AGRONOMY ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.HEAD_GROUNDSMAN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.ASSIST_HEAD_GROUNDSMAN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.HEAD_GROUNDS_PERSON ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.ASSIST_HEAD_GROUNDS_PERSON ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.GROUNDS_SUPERVISOR ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.PARKS_SUPERVISOR ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.PARKS_SUPERINTENDENT ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.SPORTS_TURG_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.DIRECTOR_ATHLETIC_FACILITIES ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.LANDSCAPE_SUPERVISOR ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.DIRECTOR_WATER_MANAGEMENT ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.WATER_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.GROUNDS_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.LEAN_GROUNDSMAN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.CEO ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.RESEARCH_AGRONOMIST);
      },
      isGroundWorxAgent() {
        return (this.$store.state.user.user_type.type_id == this.consts.UserType.AGENT);
      },
      deleteUser() {
        this.$bvModal.msgBoxConfirm(this.$t('user.deleteUserConfirmation'), {
            size: 'sm',
            buttonSize: 'sm',
            cancelVariant: 'light',
            okVariant: 'danger',
            okTitle: this.$t('general.accept'),
            cancelTitle: this.$t('general.cancel'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
          .then(async (value) => {
            if (value) {
              this.loading.deliting = true;
              await this.apiDeleteUser();
              if (process.env.VUE_APP_SENTRY_ENV == "production") {
                this.$analytics.logEvent("web_users_delete");
              }
              this.loading.deliting = false;
              this.$router.push('/users');
            }
          });
      },
      callback(res) {
        this.loading.updating = false;
        this.loading.deliting = false;
        if (process.env.VUE_APP_SENTRY_ENV == "production") {
              this.$analytics.logEvent("web_users_new");
        }
        this.$router.push('/users');
      },
      async onSubmit(e) {
        e.preventDefault();
        const isValidUserorEmail = this.validUsernameOrEmail()
        if(!isValidUserorEmail){
          this.$notify({
            text: this.$t('users.invalidUsernameEmail'),
            type: "error",
          });
          return false;
        }
        const validForm = await this.$refs.validator.validate().then((v) => v);
        
        if (validForm) {
          this.loading.updating = true;
          await this.uploadUserPhoto();
          if (this.state === 'UpdateUser') {
            if(this.isAdminOrOperationsUser() && this.current_user.type_id == this.consts.UserType.PROSPECT && this.userData.type_id != this.consts.UserType.PROSPECT){
              const course_id = this.selected_course_id;
              upgradeProspect({
                  ...this.userData,
                  course_id: course_id,
                }, 
                this.$router.currentRoute.params.id
              ).then(this.callback).catch(() => {
                this.loading.updating = false;
              });
            }else{
              updateUser(this.userData, this.$router.currentRoute.params.id)
                .then(this.callback)
                .catch(() => {
                  this.loading.updating = false;
                });
            }
          } else {
            // TODO: course_id desde el nuevo selector
            const course_id = this.isAdminOrOperationsUser() ? this.selected_course_id : this.$store.state.course.course_id;
            if(this.isSuperIntendetOrEquivalent() || this.isGroundWorxAgent()){
              this.activate_notifications = true;
            }
            saveUser({
              ...this.userData,
              course_id: course_id,
              activate_notifications: this.activate_notifications
            }).then(this.callback).catch(() => {
              this.loading.updating = false;
            });
          }
        }
      },
      onFileChanged(ev) {
        const file = ev.target.files[0];
        if (this.G_validateImage(file)) {
          this.tempPhoto = {
            file: file,
            name: file.name,
          }
          var reader = new FileReader();
          reader.onloadend = () => {
            this.userData.photo_url = reader.result;
          }
          reader.readAsDataURL(file);
        }
      },
      async uploadUserPhoto() {
        if (this.tempPhoto.file == null) {
          return true;
        }
        const formData = new FormData();
        formData.append('photo', this.tempPhoto.file, this.tempPhoto.name);
        if (this.$router.currentRoute.params.id) {
          await uploadUserPhoto(this.$router.currentRoute.params.id, formData)
            .then((res) => res.data.data)
            .then((res) => {
              if (res.success) {
                this.userData.photo_url = res.file_url;
              }
            }).catch(() => {});
        } else {
          await uploadPhotoNewUser(formData)
            .then((res) => res.data.data)
            .then((res) => {
              if (res.success) {
                this.userData.photo_url = res.file_url;
              }
            }).catch(() => {});
        }
      },
      getPolicy() {
        const componentName = 'Users';
        let menuPolicy = null;
        this.$store.state.menuPolicy.forEach((mp) => {
          if (menuPolicy == null) {
            if (mp.vue_component === componentName) {
              menuPolicy = mp;
            } else if (mp.sub_menu) {
              menuPolicy = mp.sub_menu.find((smp) => smp.vue_component === componentName);
            }
          }
        });
        if (menuPolicy) {
          this.scCanDelete = menuPolicy.policy.can_delete;
        }

      },
      validUsernameOrEmail() {
        return (this.userData.email != null && this.userData.email != undefined && this.userData.email.length > 0 || 
                this.userData.username != null && this.userData.username != undefined && this.userData.username.length > 0)
      },
    },
    mounted() {
      this.checkPasswordInput();
      this.getPolicy();
      if (this.state === 'UpdateUser') {
        this.title = this.$t('general.update');
        this.btnPhoto = this.$t('photo.editPhoto');
      } else {
        this.title = this.$t('general.create');
        this.btnPhoto = this.$t('photo.uploadPhoto');
        this.userData.status = 'ACTIVE';
      }

      if (this.$router.currentRoute.params.id) {
        getUser(this.$router.currentRoute.params.id).then((res) => {
          this.setUserSelected(res);
          this.current_user = res;
          this.userData = omit(res, ['deleted', 'time_created', 'time_updated', 'user_id', 'logo_url', 'golf_courses',
            'user_type',
          ]);
        });
      }
    },
  };

</script>

<style lang="scss" scoped>
  .user-image {
    width: 120px;
    height: 120px;
    object-fit: cover;
    border-radius: 50%;
  }

  .container-fluid {
    height: 100% !important;
  }

  .user-wrapper {
    flex-direction: column;
    height: 100% !important;
    margin-bottom: 50px;
    justify-content: center;
    width: 100%;
  }

</style>
